import React from "react";
import globalStorage from "../global-storage";

function Service() {
  const data = globalStorage.moverstripFetures;

  return (
    <section id="service" className="services section-bg">
      <div className="container" data-aos="fade-up">
        {/* Section Title */}
        <div className="section-title">
          <h2 style={{ color: "white" }}>{data.title}</h2>
          <p style={{ color: "white" }}>{data.subTitle}</p>
        </div>

        {/* Service Cards */}
        <div className="row justify-content-center">
          {data.serviceCat.map((item, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 d-flex align-items-stretch"
              style={{ marginBottom: 10 }}
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="icon-box iconbox-blue text-center">
                <div className="icon">
                  <img
                    src={item.Image}
                    className="card-img-top"
                    alt={item.title}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                </div>

                <h4>{item.title}</h4>
                <p>{item.discription}</p>

                {/* ✅ Show download button if playStore key exists */}
                {item.playStore && item.playStore.url && (
                  <a
                    href={item.playStore.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "10px",
                      backgroundColor: "#007bff",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      textDecoration: "none",
                      fontWeight: 500,
                      transition: "0.3s",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#0056b3")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#007bff")
                    }
                  >
                    {item.playStore.text || "Download Now"}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Service;
